// window.URL
window.URL = window.URL || window.webkitURL;

// toLocaleString
if (!Number.prototype.toLocaleString || Number(1234).toLocaleString() !== '1,234') {
  Number.prototype.toLocaleString = function toLocaleString() { // eslint-disable-line no-extend-native
    return String(this).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  };
}

// window.HTMLCanvasElement.prototype.toBlob
{
  const CanvasPrototype = window.HTMLCanvasElement && window.HTMLCanvasElement.prototype;
  const hasBlobConstructor = window.Blob && (() => {
    try {
      return Boolean(new Blob());
    } catch (e) {
      return false;
    }
  })();
  const hasArrayBufferViewSupport = hasBlobConstructor && window.Uint8Array && (() => {
    try {
      return new Blob([new Uint8Array(100)]).size === 100;
    } catch (e) {
      return false;
    }
  })();
  const BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
  const dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;
  const dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window.atob && window.ArrayBuffer && window.Uint8Array && ((dataURI) => {
    const matches = dataURI.match(dataURIPattern);
    if (!matches) {
      throw new Error('invalid data URI');
    }
    const mediaType = matches[2] ? matches[1] : `text/plain${matches[3] || ';charset=US-ASCII'}`;
    const isBase64 = !!matches[4];
    const dataString = dataURI.slice(matches[0].length);
    const byteString = isBase64 ? atob(dataString) : decodeURIComponent(dataString);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i += 1) {
      intArray[i] = byteString.charCodeAt(i);
    }
    if (hasBlobConstructor) {
      return new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], { type: mediaType });
    }
    const bb = new BlobBuilder();
    bb.append(arrayBuffer);
    return bb.getBlob(mediaType);
  });

  if (window.HTMLCanvasElement && !CanvasPrototype.toBlob) {
    if (CanvasPrototype.mozGetAsFile) {
      CanvasPrototype.toBlob = function (callback, type, quality) { // eslint-disable-line func-names
        if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) {
          callback(dataURLtoBlob(this.toDataURL(type, quality)));
        } else {
          callback(this.mozGetAsFile('blob', type));
        }
      };
    } else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
      CanvasPrototype.toBlob = function (callback, type, quality) { // eslint-disable-line func-names
        callback(dataURLtoBlob(this.toDataURL(type, quality)));
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/Polyfill/Polyfill.js